import { render, staticRenderFns } from "./new_strend_item.vue?vue&type=template&id=1a230d8b&scoped=true&"
import script from "./new_strend_item.vue?vue&type=script&lang=js&"
export * from "./new_strend_item.vue?vue&type=script&lang=js&"
import style0 from "./new_strend_item.vue?vue&type=style&index=0&id=1a230d8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a230d8b",
  null
  
)

export default component.exports